/**
 * Created by rkotha on 8/2/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(['$compileProvider', function ($compileProvider) {
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
        }])
        .controller('SiteAdminReportsMainController', SiteAdminReportsMainController);

    // AstbBillingController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];
    SiteAdminReportsMainController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$sce', 'siteAdminEntity', 'NasracWebContent'];

	    function SiteAdminReportsMainController($scope, Principal, LoginService,
			$state, $sce, siteAdminEntity, NasracWebContent) {
	    var vm = this;
		vm.account = null;
		vm.isAuthenticated = null;
		vm.login = LoginService.open;
		vm.register = register;
		$scope.$on('authenticationSuccess', function() {
			getAccount();
		});

		var entity = siteAdminEntity[0];
		if (entity !== undefined) {
			vm.trustedHtml = $sce.trustAsHtml(entity.content);
			vm.tinymceModel = entity.content;
		}
		
		

		getAccount();

		function getAccount() {
			Principal.identity().then(function(account) {
				vm.account = account;
				vm.isAuthenticated = Principal.isAuthenticated;
			});
		}

		function register() {
			$state.go('register');
		}

		

	}

})();
